"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  BULK_SUBMIT: "@@report-bulk/submit",
  BULK_DELETE: "@@report-bulk/bulk-delete",
  BULK_GO_LIVE: "@@report-bulk/go-live",
  BULK_ADD: "@@report-bulk/bulk-add",
  BULK_PLAY: "@@report-bulk/play",
  BULK_PAUSE: "@@report-bulk/pause",
  BULK_ALERT_ON: "@@report-bulk/alert-on",
  BULK_ALERT_OFF: "@@report-bulk/alert-off",
  BULK_LOCK: "@@report-bulk/lock",
  BULK_UNLOCK: "@@report-bulk/unlock",
  BULK_APPROVE: "@@report-bulk/approve",
  BULK_SOFT_DELETE: "@@report-bulk/soft-delete",
  BULK_SOFT_DELETE_RESTORE: "@@report-bulk/soft-delete-restore",
  RESET: "@@report-bulk/reset",
  SUCCESS: "@@report-bulk/success",
  ERROR: "@@report-bulk/error"
};
exports.actionTypes = actionTypes;